import styled, { keyframes } from 'styled-components';
import Search from '../../components/Search';

const fadeIn = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

export const Root = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1 1 100%;
	margin-bottom: ${({ isLast }) => isLast && '35px'};
	padding: 40px 0;
	color: ${({ theme }) => theme.primaryBlackColor};
	${({ theme }) => theme.typography.textM};

	@media (max-width: 768px) {
		padding-top: 8px;
	}
`;

export const Container = styled.div`
	max-width: 1400px;
	margin: 0 auto;

	@media (max-width: 1430px) {
		max-width: 100%;
		width: 100%;
		box-sizing: border-box;
		margin: 0 auto;
		padding-left: 15px;
		padding-right: 15px;
	}
`;

export const Header = styled.header`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 32px 0;

	@media (max-width: 768px) {
		margin: 16px 0 24px;
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const Title = styled.h1`
	margin: 0;
	${({ theme }) => theme.typography.headlineXL};

	@media (max-width: 768px) {
		${({ theme }) => theme.typography.headlineXXLmobile};
	}
`;

export const Buttons = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
	margin: -5px;

	a {
		margin: 5px;
	}
`;

export const PreloaderWrapper = styled.div`
	padding-top: 30px;
`;

export const ExtraButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin: 0 auto;
	padding: 40px 0 60px;
`;

export const SearchWrapper = styled.div`
	width: 30%;

	@media (max-width: 768px) {
		width: 100%;
	}
`;

export const SearchPanel = styled(Search)`
	input {
		padding-left: 0;
		border-top: none;
		border-right: none;
		border-left: none;
	}
`;

export const List = styled.div`
	margin-top: 30px;

	@media (max-width: 768px) {
		margin-top: 20px;
	}
`;

export const NotFound = styled.div`
	display: flex;
	flex: 1 1 100%;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	animation-name: ${fadeIn};
	animation-duration: 1s;
	animation-delay: 0.5s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;

	figure {
		margin: 0 auto 30px;
		padding: 0;
		width: 98px;
		height: 98px;

		img {
			width: 100%;
		}
	}

	p {
		text-align: center;
		${({ theme }) => theme.typography.headlineS};
	}
`;
